import { type TAudioSimple } from '@core/models'
import { convertAudioSimple } from '@core/converters'

import { useAudioScreenLoaderData } from './useAudioScreenLoaderData'

// Single place the raw backend DTO becomes the domain model (mirrors search's useSearchScreenResults).
export const useAudioScreenAudio = (): TAudioSimple => {
    const { audio } = useAudioScreenLoaderData()

    return convertAudioSimple(audio)
}
